import { FormValues } from './FormValues.model';

const initialValue: FormValues = {
  date: '',
  reportName: '',
};

export default initialValue;
